import { combineReducers, Dispatch } from "redux";
import { reducer as formReducer, FormReducer } from "redux-form";

// Import other reducers
import user, { UserState, logoutUser } from "./user";
import common, { CommonState } from "./common";
import snackbar, { SnackbarState } from "./snackbar";
import actionbutton, { ActionButtonState } from "./actionbutton";
import newsFeed, { NewsFeedState } from "./newsfeed";
import tupas, { TupasState } from "./tupas";
import eidentify, { EIdentifyState } from "./eidentify";
import mortgage, { IMortgageState } from "./mortgage";
import postalCodes, { IPostalCodesState } from "./postalcodes";

import loan, { LoanState } from "./loan";
import account, { AccountState } from "./account";
import portfolio, { PortfolioState } from "./portfolio";
import documentations, { DocumentationsState } from "./documentations";
import subjectCategories, { SubjectCategoriesState } from "./subjectCategories";
import messageThreads, { MessageThreadsState } from "./messages";
import profile, { ProfileState } from "./profile";
import applications, { IApplicationsState } from "./application";
import logger from "util/logger";
import creditcard, { ICreditCardState } from "./creaditcard";
import kyc, { KYCState } from "./kyc";
import loanInstalments, { LoanInstalmentsState } from "./loaninstalments";
import bulletins, { BulletinsState } from "./bulletins";
import attachments, { AttachmentState } from "./attachments";
import feedbackFeatures, { FeedbackFeatureState } from "./feedbackFeature";

export interface ReduxState {
    form: FormReducer;
    user: UserState;
    common: CommonState;
    snackbar: SnackbarState;
    actionbutton: ActionButtonState;
    newsFeed: NewsFeedState;
    tupas: TupasState;
    loan: LoanState;
    account: AccountState;
    postalCodes: IPostalCodesState;
    mortgage: IMortgageState;
    portfolio: PortfolioState;
    subjectCategories: SubjectCategoriesState;
    messageThreads: MessageThreadsState;
    bulletins: BulletinsState;
    attachments: AttachmentState;
    profile: ProfileState;
    kyc: KYCState;
    loanInstalments: LoanInstalmentsState;
    applications: IApplicationsState;
    creditcard: ICreditCardState;
    eidentify: EIdentifyState;
    documentations: DocumentationsState;
    feedbackFeatures: FeedbackFeatureState;
}

export type ReduxDispatch = Dispatch<ReduxState>;
export type ReduxGetState = () => ReduxState;

const appReducer = combineReducers<ReduxState>({
    form: formReducer,
    user,
    common,
    snackbar,
    actionbutton,
    newsFeed,
    tupas,
    loan,
    mortgage,
    account,
    portfolio,
    postalCodes,
    subjectCategories,
    messageThreads,
    bulletins,
    attachments,
    profile,
    kyc,
    loanInstalments,
    applications,
    creditcard,
    eidentify,
    documentations,
    feedbackFeatures,
});

// tslint:disable-next-line:no-any
export const rootReducer = (state: any, action: any) => {
    if (action.type === "HypoMobiili/User/LOGOUT") {
        logoutUser()
            .then(() => {
                sessionStorage.clear();
                sessionStorage.setItem("logout", "true");
            })
            .catch((err) => {
                logger.error(err);
                sessionStorage.clear();
                sessionStorage.setItem("logout", "true");
            });
        sessionStorage.setItem("logout", "true");
        state = undefined;
    }
    return appReducer(state, action);
};



// WEBPACK FOOTER //
// ./src/ducks/reducers.ts